import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=2930e5d5&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeading.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930e5d5",
  null
  
)

export default component.exports